import type { SeoService } from './core';

const GLOBAL_DESCRIPTION_COPY: Record<SeoService, string> = {
  חתונה:
    'תקליטן לחתונה עם מעל 15 שנות ניסיון, התאמה אישית ותכנון מוזיקלי לכל זוג, קריאת קהל חדה ויצירת האווירה המושלמת לכל רגע בחתונה.',
  חינה:
    'תקליטן לחינה עם מעל 15 שנות ניסיון, שליטה במוזיקה של כל העדות ושילוב מושלם בין מסורת לקצב עכשווי שהופך כל חינה לחגיגה מיוחדת.',
  'בר-מצווה':
    'תקליטן לבר/בת מצווה עם מעל 15 שנות ניסיון, מוזיקה שמותאמת לצעירים ולמבוגרים, קריאת קהל חדה וניהול מוזיקלי מדויק לכל שלב באירוע.',
  אירוע:
    'תקליטן לאירועים עם מעל 15 שנות ניסיון, שליטה במגוון רחב של סגנונות מוזיקליים, התאמה מדויקת לקהל ובניית אווירה שמתאימה לכל אירוע.',
};

const LOCAL_DESCRIPTION_COPY: Record<SeoService, (locationLabel: string) => string> = {
  חתונה: (locationLabel) =>
    `די ג׳יי לחתונה ב${locationLabel} עם מעל 15 שנות ניסיון, התאמה אישית ותכנון מוזיקלי לכל זוג, קריאת קהל חדה ויצירת האווירה המושלמת לכל רגע בחתונה.`,
  חינה: (locationLabel) =>
    `די ג׳יי לחינה ב${locationLabel} עם מעל 15 שנות ניסיון, שליטה במוזיקה של כל העדות ושילוב מושלם בין מסורת לקצב עכשווי שהופך כל חינה לחגיגה מיוחדת.`,
  'בר-מצווה': (locationLabel) =>
    `די ג׳יי לבר/בת מצווה ב${locationLabel} עם מעל 15 שנות ניסיון, מוזיקה שמותאמת לצעירים ולמבוגרים, קריאת קהל חדה וניהול מוזיקלי מדויק לכל שלב באירוע.`,
  אירוע: (locationLabel) =>
    `די ג׳יי לאירועים ב${locationLabel} עם מעל 15 שנות ניסיון, שליטה במגוון רחב של סגנונות מוזיקליים, התאמה מדויקת לקהל ובניית אווירה שמתאימה לכל אירוע.`,
};

export const HOME_SEO_DESCRIPTION =
  'תקליטן לאירועים עם מעל 15 שנות ניסיון, אלפי אירועים ועשור כדיג׳יי הבית של מועדון הפורום, מוזיקה בהתאמה אישית, קריאת קהל חדה ובניית האווירה לכל רגע באירוע.';

export function buildGlobalSeoDescription(service: SeoService) {
  return GLOBAL_DESCRIPTION_COPY[service];
}

export function buildLocalSeoDescription(service: SeoService, locationLabel: string) {
  const loc = String(locationLabel || '').trim();
  if (!loc) return buildGlobalSeoDescription(service);
  return LOCAL_DESCRIPTION_COPY[service](loc);
}
